import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const serviceFlags = function ServiceFlags() {
    const params = {},
        actions = {
            getGlobalFlag: {
                url: `${BASE_PATH_API}/external/serviceFlags/:flag`,
                method: 'GET'
            },
            getFlag: {
                url: `${BASE_PATH_API}/external/accountServiceFlags/:flag`,
                method: 'GET'
            }
        };

    return createActions(actions, params);
};
 
export const ServiceFlagApi = serviceFlags;
